import React from 'react'
import { connect } from 'react-redux'
import { Config } from '@chegg-wt/core/config'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import {
  origins,
  UserClickPayload,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import Icon from '@chegg-wt/core/components/Icon'
import { AppState } from '@chegg-wt/core/state'
import { adzoneSBMSelector } from '@chegg-wt/core/state/app/selectors'
import { layoutNameFromWidth } from '@chegg-wt/core/utils/adframe'
import reloadAds from '@chegg-wt/core/utils/ads'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { COPY_SUCCESS_INTERSTITIAL_MODAL } from '@chegg-wt/core/state/modals/constants'
import * as Styled from './styled'
import {
  ACCIDENTAL_PLAGIARISM,
  CHECK_MY_PAPER,
  CHECK_YOUR_PAPER,
  CITATION_COPIED,
  GO_BACK_TO_CITATIONS,
  GRAMMAR_ERRORS,
} from './constants'
import { CHECK_MY_PAPER_TEST_ID, GO_BACK_TO_CITATIONS_TEST_ID } from './testIds'

export interface Props {
  adzone: string
  userClick: (payload: UserClickPayload) => void
  closeModal: (name: string) => void
}

export const CopyCitationInterstitial: React.FunctionComponent<Props> = ({
  adzone,
  userClick,
  closeModal,
}) => {
  const { toPlagiarism } = useRoutesContext()
  const layout = layoutNameFromWidth(window.innerWidth)

  const onClickCheckPaper = () => {
    userClick({ origin: origins.checkPaperAfterCopy })
    if (Config.shouldOpenInNewTab) {
      window.open(routeToHref(toPlagiarism()), '_blank')
    } else {
      window.location.href = routeToHref(toPlagiarism())
    }
  }

  const onClose = () => {
    closeModal(COPY_SUCCESS_INTERSTITIAL_MODAL)
    reloadAds(adzone, 'pagechange', layout)
  }

  return (
    <>
      <Styled.TextContainer>
        <Styled.MessageIcon name="filledCheckmark" />
        <Styled.Header>{CITATION_COPIED}</Styled.Header>
        <Styled.SubHeader>{CHECK_YOUR_PAPER}</Styled.SubHeader>
        <div role="list">
          <Styled.MessageText role="listitem">
            <Icon name="checkmark" color="primaryColor" noHover />
            {ACCIDENTAL_PLAGIARISM}
          </Styled.MessageText>
          <Styled.MessageText role="listitem">
            <Icon name="checkmark" color="primaryColor" noHover />
            {GRAMMAR_ERRORS}
          </Styled.MessageText>
        </div>
      </Styled.TextContainer>
      <Styled.ButtonContainerWrapper>
        <Styled.ButtonContainer>
          <Styled.Button data-test={CHECK_MY_PAPER_TEST_ID} onClick={onClickCheckPaper}>
            {CHECK_MY_PAPER}
          </Styled.Button>
        </Styled.ButtonContainer>
        <Styled.ButtonContainer>
          <Styled.OutlineButton
            data-test={GO_BACK_TO_CITATIONS_TEST_ID}
            onClick={onClose}
          >
            {GO_BACK_TO_CITATIONS}
          </Styled.OutlineButton>
        </Styled.ButtonContainer>
      </Styled.ButtonContainerWrapper>
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  adzone: adzoneSBMSelector(state),
})

const mapDispatchToProps = {
  userClick,
  closeModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyCitationInterstitial)
